import { useMemo } from "react";
import type { ColumnDef } from "@tanstack/react-table";
import { TableActions, tableColumns } from "../components/TableColumns.tsx";
import type { VerificationStage } from "../types.ts";

export const useVerifyColumns = (
  openReview: (verificationStageId: number, attachmentIndex: number) => void,
): ColumnDef<VerificationStage>[] =>
  useMemo(
    () =>
      [
        ...tableColumns,
        {
          id: "attachments",
          header: "المرفقات",
          cell: (info: { row: { original: VerificationStage } }) => (
            <TableActions
              row={info.row.original}
              onAttachmentClick={openReview}
            />
          ),
        },
      ] as ColumnDef<VerificationStage>[],
    [openReview],
  );
